module.exports = __webpack_public_path__ + "img/categorie-epicerie-famille-boutrais.5ae98c68.webp";